// extracted by mini-css-extract-plugin
export default {"logoContainer":"BrandElement_styles_logoContainer__YTnKD"};